import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import { Form, Button, Card, Alert } from "react-bootstrap";
import Slider from "@mui/material/Slider";

import send from "./services/form";
import { questions } from "./questions.js";
import "./App.css";
import Container from "@mui/material/Container";

const marks = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

function valuetext(value) {
  return `${value}`;
}

const defaultValues = questions.map(({ questionLabel }) => ({
  questionLabel,
  questionSliderValue: 5,
  questionTextValue: "",
}));

const theme = createTheme({
  palette: {
    primary: {
      main: "#d9c588",
    },
  },
});

function App() {
  const [submitDone, setSubmitDone] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log({ values });
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      await send({ firstName, email, values });
      setSubmitDone(true);
    } catch (error) {
      setSubmitError("Vabandust, esitamisel tekkis viga. Palun proovige uuesti.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSliderChange = (event, id) => {
    const { value } = event.target;
    const newElement = { ...values[id], questionSliderValue: Number(value) };
    let newValues = [...values];
    newValues[id] = newElement;
    console.log({ newValues });
    setValues(newValues);
  };

  const handleTextChange = (event, id) => {
    const { value } = event.target;
    const newElement = { ...values[id], questionTextValue: value };
    let newValues = [...values];
    newValues[id] = newElement;
    setValues(newValues);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App d-flex justify-content-center">
        {!submitDone ? (
        <div className="container mt-4">
          <div className="header-section">
            <img
              src="logo_chanet.png"
              alt="Chanet Coaching"
              className="header-logo"
            />
            <Typography variant="h4" className="page-title">
              Eluratas
            </Typography>
            <Typography variant="subtitle1" className="page-subtitle">
              Enesehindamise küsimustik
            </Typography>
          </div>

          <Card className="intro-card">
            <Card.Body>
              <Typography variant="body1" className="intro-text">
                Hinda erinevaid valdkondi skaalal 1-10. Hinnang <strong>1</strong> tähendab,
                et sa ei ole üldse rahul ning hinnang <strong>10</strong> tähendab, et sa
                tunned suurt rahulolu ja kõik on suurepärane.
              </Typography>
              <Typography variant="body2" className="intro-hint">
                Vastates usalda enda sisetunnet ja väldi liigset analüüsi.
              </Typography>
            </Card.Body>
          </Card>
          <Form onSubmit={handleSubmit}>
            {questions.map(({ sliderQuestion, textQuestion, id }) => {
              return (
                <div key={id}>
                  <Card className="my-3 p-4 question-card">
                    <Card.Body>
                      <Form.Group className="my-1" controlId={`questionSlider${id}`}>
                        <Form.Label className="question">
                          {sliderQuestion}
                        </Form.Label>
                        <Grid container>
                          <Grid item xs={5}>
                            <Typography align="left" variant="body2">
                              Ei ole üldse rahul
                            </Typography>
                          </Grid>
                          <Grid item xs={2}></Grid>
                          <Grid item xs={5}>
                            <Typography align="right" variant="body2">
                              Suurepärane
                            </Typography>
                          </Grid>
                        </Grid>
                        <Slider
                          aria-label="Custom marks"
                          value={values[id].questionSliderValue}
                          defaultValue={5}
                          getAriaValueText={valuetext}
                          onChange={(e) => handleSliderChange(e, id)}
                          step={1}
                          min={1}
                          max={10}
                          className="mt-1 mb-3 mx-0"
                          valueLabelDisplay="auto"
                          marks={marks}
                        />
                      </Form.Group>
                      <Form.Group className="mt-5" controlId={`questionText${id}`}>
                        <Form.Label className="second-question">
                          {textQuestion}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name={`questionTextValue${id}`}
                          onChange={(e) => handleTextChange(e, id)}
                        />
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
            <Card className="info-card my-4">
              <Card.Body>
                <Typography variant="body1" className="info-text">
                  Pärast vastamist saad oma e-posti aadressile visuaalse Eluratta ülevaate, mis aitab sul näha, millised eluvaldkonnad on tasakaalus ja millised vajavad rohkem tähelepanu.
                </Typography>
              </Card.Body>
            </Card>
            <div>
              <Form.Group className="mt-5 mb-5" controlId="firstName">
                <Form.Label>Eesnimi*</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  placeholder="Sisestage eesnimi"
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group className="mt-5 mb-5" controlId="formBasicEmail">
                <Form.Label>E-posti aadress*</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Sisestage e-posti aadress"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group
                className="consent mb-3"
                controlId="formBasicCheckbox"
              >
                <Form.Check
                  type="checkbox"
                  name="consent"
                  label="Nõustun privaatsustingimustega ning sellega, et Chanet Coaching võib saata mulle testi tulemused ja edaspidi ka coachinguga seotud e-kirju.*"
                  //onChange={(e) => setConsent(e.target.value)}
                  required
                />
              </Form.Group>

              {submitError && (
                <Alert variant="danger" className="mb-3">
                  {submitError}
                </Alert>
              )}

              <Button
                variant="primary"
                type="submit"
                className="submit-button mb-5"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saadame..." : "Saa oma Eluratta ülevaade"}
              </Button>
            </div>
          </Form>

          <div className="chanet-footer">
            <div className="chanet-footer-content">
              <div className="chanet-photo-wrapper">
                <img
                  src="Chanet_Simonen_Coach.jpg"
                  alt="Chanet Siret Simonen"
                  className="chanet-photo"
                />
              </div>
              <div className="chanet-info">
                <Typography variant="h6" className="chanet-name">
                  Chanet Siret Simonen
                </Typography>
                <Typography variant="subtitle1" className="chanet-title">
                  PCC coach | Mentor | Andragoog
                </Typography>
                <ul className="chanet-achievements">
                  <li>Üle 2000 tunni praktilist coachingu kogemust</li>
                  <li>Kahe ettevõtte ning mitmete arenguprogrammide rajaja</li>
                  <li>2020. aasta koolitaja nominant</li>
                </ul>
                <Typography variant="body1" className="chanet-quote">
                  „Miks sa veel pole seal, kus tahad olla enda elus? Ehk puudub sul
                  klaarsus selles, mida päriselt südamest soovid ja mida selleks tegema pead."
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {submitDone && (
        <Container maxWidth="lg" className="submitted-container">
          <Grid container spacing={{ xs: 2, md: 1 }}>
            <Grid item xs={12}>
              <img
                src="logo_chanet.png"
                alt="Chanet Coaching"
                className="logo"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" align="center">
                Suurepärane. Aitäh, et hoolitsed enda heaolu eest. Saadame
                eluratta testi tulemused ja toetavad küsimused peagi sinu
                emailile.
              </Typography>
            </Grid>

            <Grid item xs={12} className="mb-5">
              <Typography align="center">
                Hoia enda emaili silma peal ja vaata ega meie kirjad sinu
                rämpsposti ei ole maandunud.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <img src="chanet.png" alt="Chanet Siret Simonen" />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="h6" align="left" className="website-link">
                <i>Chanet Siret Simonen</i>
              </Typography>
              <ul>
                <li>“Claarsus” tegevusmärkmiku looja.</li>
                <li>Sertifitseeritud International Coach Federation (ICF) </li>
                <li>
                  PCC taseme coach, 6. taseme koolitaja ja andragoog.
                  <br />
                  Sain lahenduskeskse coach’i kvalifikatsiooni 2015. aastal.
                  Tänaseks olen teinud üle ligi 2000 coachingu tunni ning saavutanud
                  enda coachingu teekonnal PCC taseme. Olen aidanud mitmeid
                  inimesi, meeskondi ja organisatsioone nende väljakutsete
                  juures. Olen aidanud näha imelisi visioone, kuhu soovitakse
                  liikuda ning olnud tunnistajaks ka nende visioonide
                  elluärkamisele.
                </li>
              </ul>
              <a href="https://www.chanet.ee" className="website-link">
                www.chanet.ee
              </a>
            </Grid>
          </Grid>
        </Container>
      )}
      </div>
    </ThemeProvider>
  );
}

export default App;
